import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "../styles.pcss";
import { Preloader } from "../../Preloader";
import { DropdownOption } from "./DropdownOption";
import { getIsActiveOption } from "../utils";
var cn = classNames.bind(style);
var DropdownList = /*#__PURE__*/memo(function (_ref) {
  var options = _ref.options,
    activeOption = _ref.activeOption,
    onOptionClicked = _ref.onOptionClicked,
    pending = _ref.pending,
    emptyText = _ref.emptyText,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('list', className)
  }, pending && /*#__PURE__*/React.createElement("li", {
    className: cn('preloader')
  }, /*#__PURE__*/React.createElement(Preloader, {
    size: "xs"
  })), !pending && !options.length && emptyText && /*#__PURE__*/React.createElement("li", {
    className: cn('empty')
  }, emptyText), !pending && options.map(function (option) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('option'),
      key: option.slug || option.id
    }, /*#__PURE__*/React.createElement(DropdownOption, _extends({}, option, {
      active: getIsActiveOption({
        option: option,
        activeOption: activeOption
      }),
      onClick: function onClick() {
        return onOptionClicked === null || onOptionClicked === void 0 ? void 0 : onOptionClicked(option);
      }
    })));
  }));
});
export { DropdownList };